// ConstantsHealthCalculator.js
export const SERVER_URL = "https://do-calculate.com/api";

export const BMI_EndPoint = "calculate-bmi";
export const BMI_Child_EndPoint = "calculate-child-bmi";
export const Calories_EndPoint = "calculate-calories";
export const BMR_EndPoint = "calculate-bmr";
export const IdealWeight_EndPoint = "calculate-ideal-weight";
export const BodyFat_EndPoint = "calculate-body-fat";
export const FoodEnergy_EndPoint = "calculate-food-energy";
export const healthCalculators = [
  {
    name: "Kalkulator Indeks Massa Tubuh BMI",
    link: "/calculator/id/bmiadults/",
    description: "Kalkulator ini menghitung Indeks Massa Tubuh (BMI) untuk orang dewasa. Dan menghitung berat badan ideal berdasarkan tinggi dan berat badan.",
    showMain: true,
  },
  {
    name: "Kalkulator Indeks Massa Tubuh untuk Anak BMI",
    link: "/calculator/id/bmichildren/",
    description: "Kalkulator ini digunakan untuk menghitung Indeks Massa Tubuh (BMI) untuk anak-anak.",
    showMain: true,
  },
  {
    name: "Kalkulator Kalori (BMR)",
    link: "/calculator/id/calories/",
    description:
      "Kalkulator ini menghitung jumlah kalori harian yang diperlukan untuk mempertahankan, menambah, atau menurunkan berat badan.",
    showMain: true,
  },
  {
    name: "Kalkulator Laju Metabolisme Basal BMR",
    link: "/calculator/id/bmr/",
    description:
      "Kalkulator ini menghitung laju metabolisme basal (BMR) yang menyatakan kalori yang dibutuhkan tubuh Anda saat istirahat.",
  },
  {
    name: "Kalkulator Berat Badan Ideal untuk Tinggi Badan",
    link: "/calculator/id/idealweight/",
    description: "Kalkulator ini membantu menghitung berat badan ideal yang sesuai dengan tinggi badan Anda.",
    showMain: true,
  },
  {
    name: "Kalkulator Persentase Lemak Tubuh",
    link: "/calculator/id/bodyfat/",
    description:
      "Kalkulator ini digunakan untuk menghitung persentase lemak tubuh Anda berdasarkan beberapa pengukuran.",
    showMain: true,
  },
  {
    name: "Kalkulator Karbohidrat dalam Tubuh",
    link: "/calculator/id/carbohydrate/",
    description:
      "Kalkulator ini menghitung jumlah karbohidrat yang tepat yang harus dikonsumsi setiap hari. Hitung karbohidrat.",
  },
  {
    name: "Kalkulator Konversi Satuan Energi Makanan",
    link: "/calculator/id/foodenergy/",
    description:
      "Kalkulator ini membantu mengkonversi antara berbagai satuan energi makanan seperti kalori, joule, dan kilojoule.",
  },
  {
    name: "Kalkulator Protein",
    link: "/calculator/id/protein/",
    description:
      "Gunakan Kalkulator Protein untuk memperkirakan jumlah spesifik asupan protein harian (gram/hari) untuk penurunan berat badan dan peningkatan kekuatan otot.",
    showMain: true,
  },
  {
    name: "Kalkulator Tidur Sehat",
    link: "/calculator/id/sleep/",
    description:
      "Gunakan kalkulator ini untuk menghitung waktu yang tepat untuk tidur atau bangun agar Anda bangun segar di antara siklus tidur",
    showMain: true,
  },
  {
    name: "Kalkulator Bentuk Tubuh",
    link: "/calculator/id/body-type-calculator/",
    description:
      "Kalkulator bentuk tubuh membantu Anda menentukan bentuk tubuh Anda berdasarkan ukuran dada, pinggang, paha, dan pinggul. Ini dapat memberi Anda wawasan tentang bentuk tubuh Anda.",
  },
  {
    name: "Kalkulator Jumlah Air Harian",
    link: "/calculator/id/daily-water-intake-calculator/",
    description:
      "Kalkulator jumlah air harian membantu Anda menentukan jumlah air yang tepat yang harus Anda minum setiap hari berdasarkan berat badan, tingkat aktivitas, dan iklim tempat Anda tinggal.",
  },
  {
    name: "Kalkulator Dosis Harian Vitamin",
    link: "/calculator/id/vitamin_daily_dose/",
    description:
      "Gunakan alat ini untuk menghitung dosis harian optimal vitamin yang diperlukan untuk kesehatan tubuh berdasarkan kebutuhan individu Anda. Kalkulator ini memberi Anda cara cepat untuk mengetahui dosis vitamin yang tepat.",
  },
  {
    name: "Kalkulator Nilai Gizi Makanan",
    link: "/calculator/id/food-nutrients-calculator/",
    description:
      "Gunakan alat ini untuk menghitung dosis harian optimal vitamin yang diperlukan untuk kesehatan tubuh berdasarkan kebutuhan individu Anda. Kalkulator ini memberi Anda cara cepat untuk mengetahui dosis vitamin yang tepat.",
  },
  {
    name: "Kalkulator Indeks Adipositas Tubuh BAI",
    link: "/calculator/id/bai-calculator/",
    description:
      "Gunakan kalkulator ini untuk menentukan Indeks Adipositas Tubuh (BAI) Anda secara akurat",
  },
  {
    name: "Kalkulator Bentuk Wajah",
    link: "/calculator/id/face-shape-calculator/",
    description:
      "Kalkulator ini menentukan bentuk wajah berdasarkan pengukuran dan fitur wajah.",
  },
  {
    name: "Kalkulator Kadar Gula Darah",
    link: "/calculator/id/blood-sugar-calculator/",
    description: "Gunakan kalkulator ini untuk menghitung kadar gula dalam darah",
  },
  {
    name: "Kalkulator Risiko Diabetes",
    link: "/calculator/id/diabetes-risk-calculator/",
    description:
      "Hitung persentase risiko terkena diabetes dalam 7,5 tahun berdasarkan data kesehatan Anda.",
  },
  {
    name: "Kalkulator Rata-rata Glukosa Perkiraan",
    link: "/calculator/id/estimated-average-glucose-calculator/",
    description:
      "Gunakan kalkulator ini untuk menghitung perkiraan rata-rata glukosa berdasarkan persentase HbA1c.",
  },
  {
    name: "Kalkulator Dosis Obat - Kalkulator Dosis Farmasi",
    link: "/calculator/id/medicine-dosage-calculator/",
    description:
      "Gunakan kalkulator ini untuk menghitung dosis harian yang tepat berdasarkan berat badan pasien.",
  },
  {
    name: "Kalkulator Dosis Parasetamol untuk Anak",
    link: "/calculator/id/children-paracetamol-dosage-calculator/",
    description:
      "Gunakan kalkulator ini untuk menghitung dosis harian parasetamol yang tepat berdasarkan berat badan anak dan konsentrasi obat.",
  },
  {
    name: "Kalkulator Fungsi Ginjal - Hitung Laju Filtrasi Glomerulus GFR",
    link: "/calculator/id/gfr-calculator/",
    description:
      "Gunakan kalkulator laju filtrasi glomerulus (GFR) untuk memperkirakan efisiensi fungsi ginjal berdasarkan kadar kreatinin dalam darah. Kalkulator ini memberikan perkiraan akurat fungsi ginjal dan membantu dalam diagnosis dini penyakit ginjal. Mengetahui GFR Anda dapat menjadi langkah penting untuk menjaga kesehatan ginjal.",
  },
  {
    name: "Tes Mata - Kalkulator Pemeriksaan dan Pengukuran Mata",
    link: "/calculator/id/eye-test/",
    description:
      "Kalkulator melakukan pemeriksaan mata dengan sederhana dan jelas berdasarkan tes Snellen",
  },
  {
    name: "Kalkulator Target Denyut Jantung saat Berolahraga",
    link: "/calculator/id/heartbeat-calculator/",
    description: "Hitung target denyut jantung ideal berdasarkan usia dan intensitas olahraga Anda.",
  },
  {
    name: "Kalkulator Kecanduan",
    link: "/calculator/id/addiction-calculator/",
    description: "Hitung jumlah tahun yang hilang akibat kecanduan.",
  },
  {
    name: "Kalkulator Pemulihan dari Merokok",
    link: "/calculator/id/smoking-recovery-calculator/",
    description: "Temukan manfaat berhenti merokok dan sejauh mana peningkatan kesehatan Anda",
  },
  {
    name: "Kalkulator Rasio Kolesterol",
    link: "/calculator/id/cholesterol-ratio-calculator/",
    description: "Kalkulator ini membantu Anda mengetahui rasio kolesterol dan kesehatan jantung",
  },
  {
    name: "Kalkulator Kalori dari Langkah",
    link: "/calculator/id/steps-to-calories/",
    description: "Hitung kalori yang terbakar berdasarkan jumlah langkah yang Anda berjalan.",
  },
  {
    name: "Kalkulator Kalori dari Berjalan",
    link: "/calculator/id/walking-calories/",
    description: "Kalkulator kalori berjalan menghitung jumlah kalori yang Anda bakar saat berjalan atau berlari di treadmill.",
  },
  {
    name: "Kalkulator Tingkat Konsumsi Kopi Harian",
    link: "/calculator/id/coffee-caffeine/",
    description: "Kalkulator tingkat konsumsi kopi harian untuk mengetahui jumlah kafein yang tepat untuk Anda berdasarkan berat badan dan jenis kopi",
  }
];
export default healthCalculators;